import { defineMessages, type MessageDescriptor } from 'react-intl';

import { GAMIFICATION_EVENT_TYPES } from '@didaskill/domain/gamification-events/constants';
import {
  ACHIEVEMENT_TYPES,
  type QuestAchievementType,
} from '@didaskill/domain/user-achievements/constants';

type AchievementCategoryMessages = Record<
  QuestAchievementType,
  Partial<Record<GAMIFICATION_EVENT_TYPES, { DESCRIPTION: MessageDescriptor }>>
>;

export const gamificationEventsMessages: AchievementCategoryMessages = {
  [ACHIEVEMENT_TYPES.CAMPUS_EXPLORER]: {
    [GAMIFICATION_EVENT_TYPES.APPOINTMENT_SCHEDULED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Prendre rdv avec mon coach ou référent',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.VIRTUAL_CLASSROOM_ATTENDED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Assister à une classe virtuelle (ou visionner le replay)',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.LESSON_COMPLETED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Finaliser un cours',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.PROFILE_PICTURE_UPDATED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Mettre à jour ma photo de profil',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.AUDIO_LISTENED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Écouter un cours audio',
      },
    }),
  },
  [ACHIEVEMENT_TYPES.GOOD_HABITS]: {
    [GAMIFICATION_EVENT_TYPES.FLASHCARDS_DECK_CREATED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Créer un nouveau paquet de flashcards',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.ACTIVE_SESSION]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Se connecter 15 fois sur le campus',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.EXERCISE_COMPLETED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Terminer deux exercices',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.LEARNING_RESOURCE_VIEW]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Consulter les ressources dans la bibliothèque',
      },
    }),

    [GAMIFICATION_EVENT_TYPES.LESSON_ASK_IA]: defineMessages({
      DESCRIPTION: {
        defaultMessage: "Poser une question à l'IA sur un cours",
      },
    }),
  },
  [ACHIEVEMENT_TYPES.GAIN_CONFIDENCE]: {
    [GAMIFICATION_EVENT_TYPES.ACTIVE_SESSION]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Se connecter 20 fois sur le campus',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.FEEDBACK_CAMPAIGN_ANSWERED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Répondre à un sondage',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.FLASHCARDS_DECK_COMPLETED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Terminer un paquet de flashcards',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.MULTIPLE_EXERCISE_ATTEMPTS_COMPLETED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Réaliser un même exercice plusieurs fois',
      },
    }),
  },
  [ACHIEVEMENT_TYPES.SNAP_FINGERS]: {
    [GAMIFICATION_EVENT_TYPES.APPOINTMENT_SCHEDULED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Prendre un deuxième rendez-vous',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.EXERCISE_COMPLETED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Terminer 3 exercices',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.LESSON_COMPLETED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Finaliser 2 cours',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.VIRTUAL_CLASSROOM_ATTENDED]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Assister à 2 classes virtuelles',
      },
    }),
    [GAMIFICATION_EVENT_TYPES.EXERCISE_PERFECT_SCORE]: defineMessages({
      DESCRIPTION: {
        defaultMessage: 'Obtenir 100% à un exercice',
      },
    }),
  },
};
